import { render, staticRenderFns } from "./SimplifiedSplashMobile.vue?vue&type=template&id=920f32c4"
import script from "./SimplifiedSplashMobile.vue?vue&type=script&lang=js"
export * from "./SimplifiedSplashMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports